module.exports = __webpack_public_path__ + "static/img/red-giftbox.cf7562ba.png";